import styled from "styled-components";

const KycFailWrapper = styled.div`
	border-radius: 12px;
	background: var(--White, #FFF);
	box-shadow: 0px 4px 10px 0px rgba(9, 30, 66, 0.00);
	width: 60%;
	margin: 1rem auto;

	@media screen and (max-width: 875px) {
		width: 85%;
	}
`;

export default KycFailWrapper;
